import { useEffect, useState } from 'react'

import { useLocation, useNavigate } from 'react-router'

type SSOAccountActivatedState = {
  ssoAccountActivated?: boolean
}

/** SSOユーザーのアカウント有効化直後に着地したかどうかを、遷移元から渡された location.state で判定する
 *
 * 判定に使ったフラグは履歴から取り除くため、リロードやブラウザバックでは再表示されない
 */
export const useSSOAccountActivated = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const activated =
    (location.state as SSOAccountActivatedState | null)?.ssoAccountActivated ??
    false
  const [isOpen, setIsOpen] = useState(activated)

  useEffect(() => {
    if (activated) {
      // searchは必ず引き継ぐ。落とすとSSOログインボタンの表示に使う`?login=sso`が消える
      navigate(
        { pathname: location.pathname, search: location.search },
        { replace: true, state: {} },
      )
    }
  }, [activated, location.pathname, location.search, navigate])

  return { isOpen, onClose: () => setIsOpen(false) }
}
